import { I18n } from '@calendly/i18n'
import { VisuallyHidden } from '@calendly/ui/components/visually-hidden'
import PropTypes from 'prop-types'
import { Component } from 'react'

import Settings from 'core/settings'

import CropPopup from './crop_popup'

export default class ImageUpload extends Component {
  static propTypes = {
    cropShape: PropTypes.oneOf(['round', 'rectangle']),
    cropRatio: PropTypes.number,
    validate: PropTypes.bool,
    onFileSelect: PropTypes.func.isRequired,
    onFileError: PropTypes.func.isRequired
  }

  static defaultProps = {
    cropShape: 'rectangle',
    validate: false,
    cropRatio: null
  }

  constructor(props) {
    super(props)

    this.state = {
      fileType: null,
      fileUrl: null,
      cropping: false
    }
  }

  startCropping = (file) => {
    this.setState({
      fileType: file.type,
      fileUrl: URL.createObjectURL(file),
      cropping: true
    })
  }

  onFileSelect = (event) => {
    const file = event.target.files[0]

    const isCroppable = file.type.match(/^image\//)

    if (!isCroppable) {
      this.props.onFileSelect({
        file,
        previewDataUrl: URL.createObjectURL(file)
      })
      return
    }

    // validate before showing crop UI
    if (this.props.validate && file.size > Settings.maxUploadFileSize) {
      const rejectedSize = (file.size / 1024 / 1024).toPrecision(2)
      const translatedError = I18n.t('errors.messages.uploaded_image_too_large', {
        allowed_size: Settings.maxUploadFileSize / 1024 / 1024,
        rejected_size: rejectedSize
      })

      this.props.onFileError(translatedError)
      return
    }

    const input = event.target
    input.value = ''
    this.startCropping(file)
  }

  onConfirmCrop = ({ previewDataUrl, file }) => {
    this.setState({ cropping: false })
    this.props.onFileSelect({ previewDataUrl, file })
  }

  onCancelCrop = () => {
    this.setState({ cropping: false })
  }

  render() {
    return (
      <>
        <VisuallyHidden
          as="input"
          type="file"
          accept=".jpg, .jpeg, .png, .gif"
          onChange={this.onFileSelect}
        />
        <CropPopup
          isOpen={this.state.cropping}
          fileUrl={this.state.fileUrl}
          fileType={this.state.fileType}
          onConfirm={this.onConfirmCrop}
          onCancel={this.onCancelCrop}
          onError={this.props.onFileError}
          cropShape={this.props.cropShape}
          cropRatio={this.props.cropRatio}
        />
      </>
    )
  }
}
